import { marketingAdministratorRoles } from "../config/roles";
import { ListDefinition } from "./listDefinition.types";

const recordRoute = "/reporting-campaign";

/**
 * The reporting campaigns list. Every campaign comes back in one request, so its
 * filters narrow what is already loaded rather than asking again.
 */
export const campaignsListDefinition: ListDefinition = {
  path: "/reporting-campaigns",
  entityName: "campaign",
  recordRoute,
  title: "Reporting Campaigns",
  allowedRoles: marketingAdministratorRoles,
  data: "all-at-once",
  filters: [
    // Matched against the record's name, which is what the legacy free-text filter
    // searched here. The only filter on show: the two dates are for narrowing a name
    // search, not for starting one.
    {
      name: "Name",
      label: "Name",
      kind: "text",
      searchFields: ["Name"],
      width: "wide",
    },
    {
      name: "createdon",
      label: "Created",
      kind: "date-range",
      advanced: true,
    },
    {
      name: "modifiedon",
      label: "Modified",
      kind: "date-range",
      advanced: true,
    },
  ],
  filterByStatus: true,
  allowAdd: true,
  allowStatusEdit: true,
  columns: [
    {
      key: "Name",
      label: "Name",
      width: 300,
      sortable: true,
      link: { to: recordRoute, idKey: "Id", newTab: "button" },
    },
    {
      key: "createdon",
      label: "Created On",
      width: 200,
      display: "datetime",
      sortable: true,
    },
    {
      key: "modifiedon",
      label: "Modified On",
      width: 200,
      display: "datetime",
      sortable: true,
    },
  ],
};
